module.exports = __webpack_public_path__ + "static/media/attendance_Report.66deddad.png";